// layouts/Customization/components/BusinessObjectsTab.js
import React, { useState } from 'react';
import ArgonBox from 'components/ArgonBox';
import ArgonTypography from 'components/ArgonTypography';
import {
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Icon,
  IconButton,
} from '@mui/material';
import { grey } from '@mui/material/colors';
import BusinessObjectDetails from './BusinessObjectDetails';

const demoBusinessObjects = [
  {
    name: 'Usage Mappings',
    purpose: 'Links Products to usage metrics for billing',
    lastModified: '2024-01-20',
    columns: [
      { name: 'Product', type: 'Lookup' },
      { name: 'Usage Metric', type: 'Lookup' },
      { name: 'Billing Term', type: 'Picklist' },
      { name: 'UOM', type: 'Text' },
    ],
    records: [
      { Product: 'Product A', 'Usage Metric': 'GB Used', 'Billing Term': 'Monthly', UOM: 'GB' },
      { Product: 'Product B', 'Usage Metric': 'Minutes Used', 'Billing Term': 'Annually', UOM: 'Minutes' },
      { Product: 'Product C', 'Usage Metric': 'Transactions', 'Billing Term': 'Monthly', UOM: 'Count' },
    ],
  },
  {
    name: 'Discount Eligibility',
    purpose: 'Stores discount eligibility rules by customer segment',
    lastModified: '2024-02-15',
    columns: [
      { name: 'Customer Segment', type: 'Picklist' },
      { name: 'Contract Term', type: 'Picklist' },
      { name: 'Discount Amount', type: 'Currency' },
    ],
    records: [
      { 'Customer Segment': 'Enterprise', 'Contract Term': '36 Months', 'Discount Amount': '$1000' },
      { 'Customer Segment': 'SMB', 'Contract Term': '12 Months', 'Discount Amount': '$500' },
    ],
  },
];

function BusinessObjectsTab() {
  const [selectedBusinessObject, setSelectedBusinessObject] = useState(null);

  const handleViewDetails = (bo) => {
    setSelectedBusinessObject(bo);
  };

  const handleCloseDetails = () => {
    setSelectedBusinessObject(null);
  };

  if (selectedBusinessObject) {
    return <BusinessObjectDetails businessObject={selectedBusinessObject} onClose={handleCloseDetails} />;
  }

  return (
    <Card>
      <ArgonBox p={3}>
        <TableContainer component={Paper}>
          <Table aria-label="business objects table">
            <TableHead sx={{ display: 'contents' }}>
              <TableRow>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '14px', color: grey[700] }}>Name</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '14px', color: grey[700] }}>Description</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '14px', color: grey[700] }}>Last Modified</TableCell>
                <TableCell align="right" sx={{ fontWeight: 'bold', fontSize: '14px', color: grey[700] }}>
                  Actions
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {demoBusinessObjects.map((bo, index) => (
                <TableRow key={index}>
                  <TableCell sx={{ fontSize: '11pt' }}>{bo.name}</TableCell>
                  <TableCell sx={{ fontSize: '11pt' }}>{bo.purpose}</TableCell>
                  <TableCell sx={{ fontSize: '11pt' }}>{bo.lastModified}</TableCell>
                  <TableCell align="right">
                    <Button
                      variant="contained"
                      color="info"
                      size="small"
                      sx={{ mr: 1 }}
                      onClick={() => handleViewDetails(bo)}
                    >
                      View Details
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </ArgonBox>
    </Card>
  );
}

export default BusinessObjectsTab;
